import React, { useState } from 'react'
import http from '../../utils/axiosinterceptors'
import fileDownload from 'js-file-download'
import { toast } from 'react-toastify'
import { Spinner } from 'react-bootstrap'

const StatistikHisobot = ({ startDate, endDate }) => {
    const [isCountry, setIsCountry] = useState(false)
    const [loading, setLoading] = useState(false)
    const [tog, setTog] = useState('FSS')
    const [murojat, setMurojat] = useState('all')


    const submitForm = (e) => {
        e.preventDefault()
        setLoading(true)

        http.get(`api/report/statistic`, {
            params: {
                mode: tog,
                is_country: isCountry,
                murojat: tog === 'FSS' && murojat !== 'all' ? murojat : null,
                from_date: startDate ? startDate : null,
                end_date: endDate ? endDate : null
            },
            responseType: "blob"
        })
            .then(res => {
                fileDownload(res.data, 'hisobot.zip')
            }).catch(err => {
                toast.error("Xatolik", {
                    position: toast.POSITION.BOTTOM_RIGHT
                })
            }).finally(() => {
                setLoading(false)
            })
    }


    return (
        <div>
            <h1>Statistik hisobot</h1>
            <div className='atb-component'>
                <form onSubmit={submitForm}>
                    <div className='toggle'>
                        <div className={tog === 'FSS' ? 'active-tog' : ''} onClick={() => setTog('FSS')}>FSS (export)</div>
                        <div className={tog === 'AKD' ? 'active-tog' : ''} onClick={() => setTog('AKD')}>AKD (import)</div>
                    </div>

                    {
                        tog === 'FSS' ? (
                            <div className='toggle three-toggle murojat-toggle'>
                                <div className={murojat === 'all' ? 'active-tog' : ''} onClick={() => setMurojat('all')}>Barchasi</div>
                                <div className={murojat === 'with' ? 'active-tog' : ''} onClick={() => setMurojat('with')}>Murojat raqami bor</div>
                                <div className={murojat === 'without' ? 'active-tog' : ''} onClick={() => setMurojat('without')}>Murojat raqami yo'q</div>
                            </div>
                        ) : null
                    }

                    <div className='btn-wrap'>
                        {
                            tog === 'free' ? null : (
                                <input type='checkbox' title='' checked={isCountry} value={isCountry} onChange={() => setIsCountry(!isCountry)} />
                            )
                        }
                        <button type='submit' className='load' disabled={loading}>
                            {loading ? <Spinner animation="border" /> : null}
                            {loading ? null : 'Yuklab olish'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default StatistikHisobot